






























import { Vue, Component } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { CommonService } from "@/zh-website/src/views/Enterprise/service/CommonService";
@Component({
  components: {
    Banner,
    SideBar
  }
})
export default class SuccessCaseDetail extends Vue {
  navigationName = "" as any;
  solutionId = "";
  classifyName = "" as any;
  caseName = "" as any;
  classifyLink = "" as any;
  navigationLink = "" as any;
  result = "" as any;
  bannerData = {
    font4: "他山之石 可以攻玉",
    font5: "使能千行百业数字化人才转型",
    font3: "",
    button: "",
    style: {
      "background-image":
        'url("' + require("../../../../assets/case_banner.jpg") + '")',
      height: "320px"
    }
  };
  CaseDetail = {} as any;

  mounted() {
    //根据路由的id获取案例详情

    this.getSuccessCasesList();
    this.getSuccessCasesDetail();
  }
  getAllNavigation() {
    // CommonService.getAllClassification({}).then((res: any) => {
    //   console.log("getAllClassification", res);
    //   res.data.forEach((nav: any, index) => {
    //     //set the jump link
    //     console.log("遍历", nav);
    //     let link: string = "";
    //     if (index == 0) link = "industry";
    //     else if (index == 1) link = "product";
    //     else if (index == 2) link = "digital";
    //     nav.child.forEach((classify: any) => {
    //       console.log("遍历1", classify);
    //       if (classify.child) {
    //         classify.child.forEach((solution: any) => {
    //           console.log("遍历2", solution);
    //           if (solution.id == this.CaseDetail.solutionId) {
    //             this.classifyName = classify.name;
    //             this.navigationName = nav.name;
    //             this.caseName = solution.name;
    //             this.navigationLink = `/enterprise/${link}/page`;
    //             if (link == "industry")
    //               this.navigationLink = `/enterprise/page`;
    //             this.classifyLink = `/enterprise/${link}/classify/${classify.id}`;
    //           }
    //         });
    //       }
    //     });
    //   });
    // });
  }

  getSuccessCasesList() {
    CommonService.getSuccessCasesList({
      solutionId: this.$route.params.id
    }).then((res: any) => {
      // console.log("getSuccessCasesList", res);
    });
  }
  getSuccessCasesDetail() {
    CommonService.getSuccessCasesDetail({ id: this.$route.params.id }).then(
      (res: any) => {
        this.CaseDetail = res.data;
        this.getAllNavigation();
      }
    );
  }
}
